import { useGomakeTheme } from "@/hooks/use-gomake-thme";
import { useTheme } from "@/contexts/theme/useTheme";
import { HpPlusIcon } from "@/themes/hp-client/icons/HpPlusIcon";

const SIZE_MAP = {
  small: { width: 16, height: 16 },
  medium: { width: 24, height: 24 },
} as const;

type Size = keyof typeof SIZE_MAP;

interface AddPlusIconProps {
  stroke?: string;
  width?: number;
  height?: number;
  size?: Size;
}

const AddPlusIcon = (props: AddPlusIconProps) => {
  const { primaryColor } = useGomakeTheme();
  const { currentTheme } = useTheme();
  const stroke = props.stroke || primaryColor(300);

  if (currentTheme === "hp-client") {
    const size = props.size ?? "medium";
    const dimensions = SIZE_MAP[size];
    const width = props.width ?? dimensions.width;
    const height = props.height ?? dimensions.height;
    return (
      <HpPlusIcon
        color={props.stroke ?? "var(--theme-combobox-icon-color, #1A1A1A)"}
        width={width}
        height={height}
      />
    );
  }

  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33398 8.08716H10.6673"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10.7539V5.42053"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.00065 14.7539H10.0007C13.334 14.7539 14.6673 13.4205 14.6673 10.0872V6.0872C14.6673 2.75387 13.334 1.42053 10.0007 1.42053H6.00065C2.66732 1.42053 1.33398 2.75387 1.33398 6.0872V10.0872C1.33398 13.4205 2.66732 14.7539 6.00065 14.7539Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { AddPlusIcon };
